import { createSlice } from "@reduxjs/toolkit";
import { rowsPerPageJsonData } from "../utils/JsonData";
import moment from "moment";

const initialState = {

  occupancySearchFilters: {
    startDate: moment().add(1, "days").format("YYYY-MM-DD"),
    endDate: moment().add(8, "days").format("YYYY-MM-DD"),
  },
  occupanychartData: {
    categories: [],
    series: [],
  },
  marketAnalysisOwnHotelId: JSON.parse(localStorage.getItem("userDetails"))?.hotel_id,
  marketAnalysisResources: [{
    competitor_hotel_name: "None",
  }],
  marketAnalysisCalenderView: {
      initialDate: moment().format("YYYY-MM-DD"),
      perMonth: 7,
  },
  marketAnalysisEventss: [],
  bookingPatternSearchFilters: {
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().add(30, "days").format("YYYY-MM-DD"),
  },
  bookingPatternMonthsDatas: [],
};
const revenueGenerationSlice = createSlice({
  name: "revenueGeneration",
  initialState: initialState,
  reducers: {
    occupancySearchFiltersSuccess: (state, action) => {
      state.occupancySearchFilters = {...state.occupancySearchFilters, [action.payload.key]: action.payload.value};
    },
    occupanychartDataSuccess: (state, action) => {
        state.occupanychartData = action.payload;
      },
    bookingPatternSearchFiltersSuccess: (state, action) => {
      state.bookingPatternSearchFilters = {...state.bookingPatternSearchFilters, [action.payload.key]: action.payload.value};
    },
    bookingPatternMonthsDatasSuccess: (state, action) => {
        state.bookingPatternMonthsDatas = action.payload;
      },
    marketAnalysisCalenderViewSuccess: (state, action) => {
      state.marketAnalysisCalenderView = {...state.marketAnalysisCalenderView, [action.payload.key]: action.payload.value};
    },
    marketAnalysisOwnHotelIdSuccess: (state, action) => {
        state.marketAnalysisOwnHotelId = action.payload;
      },
    marketAnalysisResourcesSuccess: (state, action) => {
        state.marketAnalysisResources = action.payload;
      },
    marketAnalysisEventssSuccess: (state, action) => {
        state.marketAnalysisEventss = action.payload;
      },
  },
});

export const {
    occupancySearchFiltersSuccess,
    occupanychartDataSuccess,
    marketAnalysisCalenderViewSuccess,
    marketAnalysisOwnHotelIdSuccess,
    marketAnalysisResourcesSuccess,
    marketAnalysisEventssSuccess,
    bookingPatternSearchFiltersSuccess,
    bookingPatternMonthsDatasSuccess,
} = revenueGenerationSlice.actions;
export default revenueGenerationSlice.reducer;
